import { useEffect, useRef } from 'react';
import { useAuth } from '../auth/AuthContext';
import { hasAdFreeExperience } from '../lib/coachAccess';
import { showWebMonetization } from '../lib/platform';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

const ADSENSE_CLIENT =
  (import.meta.env.VITE_ADSENSE_CLIENT as string | undefined)?.trim() ||
  'ca-pub-1500381956956085';
const ADSENSE_SLOT = (import.meta.env.VITE_ADSENSE_SLOT as string | undefined)?.trim();

export function PageBannerAd() {
  const { user } = useAuth();
  const pushed = useRef(false);
  const insRef = useRef<HTMLModElement>(null);

  const enabled = showWebMonetization() && Boolean(user) && !hasAdFreeExperience(user) && Boolean(ADSENSE_SLOT);

  useEffect(() => {
    if (!enabled || pushed.current) return;

    const pushAd = () => {
      if (pushed.current || !insRef.current) return;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch {
        /* Ad blockers or script not ready */
      }
    };

    if (window.adsbygoogle) {
      pushAd();
      return;
    }

    const timer = window.setInterval(() => {
      if (window.adsbygoogle) {
        window.clearInterval(timer);
        pushAd();
      }
    }, 400);

    return () => window.clearInterval(timer);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <aside
      className="mt-4 flex justify-center border-t border-white/[0.06] pt-3"
      aria-label="Advertisement"
    >
      <div className="w-full max-w-[728px] overflow-hidden rounded-lg opacity-80 transition-opacity hover:opacity-100">
        <ins
          ref={insRef}
          className="adsbygoogle block"
          style={{ display: 'block', minHeight: 50, maxHeight: 90 }}
          data-ad-client={ADSENSE_CLIENT}
          data-ad-slot={ADSENSE_SLOT}
          data-ad-format="horizontal"
          data-full-width-responsive="true"
        />
      </div>
    </aside>
  );
}
